import React from "react";
import Spinner from "../Spinner/Spinner";
import DesignOptionGallery from "../DesignOptionGallery/DesignOptionGallery";

var ParallelCoordinates = require("react-parallel-coordinates");
var Papa = require("papaparse/papaparse.min.js");

export default class ViewSpace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: window.location.href.split("view-spaces/")[1],
            items: null,
            gridData: null,
            paarcoordsData: null,
            dimensions: null,
            paarcoordsWidth: null,
            imageWidth: null,
        };
        this.updateData = this.updateData.bind(this);
        this.filterData = this.filterData.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.getImageWidth = this.getImageWidth.bind(this);
    }

    componentWillMount() {
        Papa.parse(
            "https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/spaces/" +
            this.state.id +
            "/data/data.csv",
            {
                header: true,
                download: true,
                skipEmptyLines: true,
                dynamicTyping: true,
                complete: this.updateData,
            }
        );
        this.updateDimensions();
    }

    updateDimensions() {
        this.setState({
            paarcoordsWidth:
                window.innerWidth - 40 ||
                document.documentElement.clientWidth - 40 ||
                document.body.clientWidth - 40,
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateData(result) {
        this.extractHeaders(result.data);
        this.updateGridData(result.data);
        this.setState({ paarcoordsData: result.data, items: result.data });
    }

    updateGridData(data) {
        var output = [];
        for (var i = 0; i < data.length; i++) {
            output.push({
                src:
                    "https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/spaces/" +
                    this.state.id +
                    "/images/" +
                    data[i].img,
                link: "/view-spaces/" + this.state.id,
                title: data[i]["name"],
                description: data[i],
            });
        }
        this.getImageWidth(output[0].src);
        this.setState({ gridData: output });
    }

    filterData(data) {
        this.updateGridData(data);
    }

    extractHeaders(data) {
        var output = {};
        for (var i = 0; i < Object.keys(data[0]).length; i++) {
            if (
                Object.keys(data[0])[i] !== "threeD" &&
                Object.keys(data[0])[i] !== "img" &&
                Object.keys(data[0])[i] !== "name"
            ) {
                output[Object.keys(data[0])[i]] = {
                    title: Object.keys(data[0])[i],
                    type: typeof data[0][Object.keys(data[0])[i]],
                };
            }
        }
        this.setState({ dimensions: output });
    }

    getImageWidth(src) {
        // lightbox component only accepts image width as props
        // but we want to keep a constant height to save space for the caption
        let that = this;
        var img = new Image();
        img.onload = function () {
            let newWidth = (400 * this.width) / this.height;
            that.setState({ imageWidth: newWidth });
        };
        img.src = src;
    }

    createDash() {
        if (!this.state.items) {
            return <Spinner />;
        } else {
            const props = {
                // colour: "#069",
                width: this.state.paarcoordsWidth,
                height: 500,
                dimensions: this.state.dimensions,
                data: this.state.paarcoordsData,
                onBrushEnd_data: this.filterData,
                dimensionTitleRotation: 0,
            };
            return (
                <div className="container-fluid">
                    <ParallelCoordinates {...props} />
                    <div className="container">
                        <DesignOptionGallery
                            gridData={this.state.gridData}
                            imageWidth={this.state.imageWidth}
                        />
                    </div>
                </div>
            );
        }
    }

    render() {
        return <div>{this.createDash()}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/ViewSpace/ViewSpace.js